import React from 'react';
import VstComponent from './VstComponent';
import addClassName from '../utils/add-class-name';
import copyProps from '../utils/copy-props';
import classNames from 'classnames';
import namespaceOptions from '../utils/namespace-options';

class VstCard extends VstComponent {

  render() {
    let props = addClassName(this.props, classNames(namespaceOptions('vst', this.props.options), 'vst-card'));
    props = copyProps(props, ['options']);

    return (
      <li className="vst-card" {...props}>
        {this.props.children}
      </li>
    );
  }
}

export default VstCard;
